export const s3Host = 'https://dbknews-assets.s3.amazonaws.com/kpop.dbknews.com'
